import AppConstants from "../../constants";
import moment from "moment";
import { getDateOrTimeInReqFormat } from "../../utils/dateUtils";
import { getFilterAttributeValue } from "../SharedTransform/response.transforms";


export interface Content {
  id: string;
  module: string;
  type: string;
  createdBy: string;
  createdAt: string;
  status: string;
  progress: string;
  filePath: string;
}

export interface ReportsOrdersDataResponse {
  pageNumber: number;
  totalElements: number;
  totalPages: number;
  continuationToken?: string;
  elements: Content[];
}

const lastMileUserDataTransform = (
  response: ReportsOrdersDataResponse
): any[] => {
  const transformedArray: any[] = [];
  response?.elements?.forEach((content: Content) => {
    const {
      id,
      module,
      type,
      createdBy,
      createdAt,
      status,
      progress,
      filePath,
    } = content;
    transformedArray.push({
      id: id,
      module: module,
      type: type,
      createdBy: createdBy,
      createdAt:
        createdAt &&
        getDateOrTimeInReqFormat(createdAt, AppConstants.DATE_TIME_FORMAT),
      status: status,
      progress: progress,
      filePath: filePath,
    });
  });
  return [...transformedArray];
};

export { lastMileUserDataTransform };

export const createFilterPayload = (
  payload: any,
  data?: any,
  isLoadMore?: boolean
) => {
  payload.attributes = [];
  if (payload.type) {
    if (payload.type.value) {
      payload.type = payload.type.value;
    } else {
      payload.type = "";
    }
  }
  /** serviceType */
  if (payload.module) {
    if (payload.module.value) {
      payload.module = payload.module.value;
    } else {
      payload.module = "";
    }
  }
  if (payload.status.value.length > 0) {
    let attrValue = [];
    if (payload.status.value) {
      attrValue = getFilterAttributeValue(payload.status.value);
      payload.attributes.push({
        key: payload.status.key,
        value: attrValue,
      });
    }
  } else {
    delete payload.status;
  }

  if (payload.dateRange) {
    if (payload.dateRange && payload.dateRange.value) {
      payload.isDateRange = true;
      payload.dateRange = {
        startTime: moment(
          payload.dateRange.value.startDate,
          AppConstants.DATE_FORMAT
        )
          .hours(0)
          .minutes(0)
          .seconds(0)
          .format(AppConstants.DATE_FORMAT_BACKEND),
        endTime: moment(
          payload.dateRange.value.endDate,
          AppConstants.DATE_FORMAT
        )
          .hours(23)
          .minutes(59)
          .seconds(59)
          .format(AppConstants.DATE_FORMAT_BACKEND),
      };
    }
  }

  if (isLoadMore && data) {
    payload.pageNumber = data.pageNumber + 1 < data.totalPages ? data.pageNumber + 1 : payload.pageNumber;
  }
  delete payload.filter;
  return payload;
};
